import { z } from "zod";

export const TaskIconIdSchema = z.enum([
  "general",
  "reading",
  "writing",
  "math",
  "language",
  "piano",
  "strings",
  "music",
  "sports",
  "swimming",
  "art",
  "science",
  "computer",
  "school",
  "chores",
  "care",
  "nature",
  "cooking",
]);
export type TaskIconId = z.infer<typeof TaskIconIdSchema>;
export const TaskIconResolveRequestSchema = z
  .object({
    items: z
      .array(z.object({ task_id: z.uuid(), assignment_id: z.uuid() }).strict())
      .min(1)
      .max(40)
      .refine((items) => new Set(items.map((i) => i.assignment_id)).size === items.length),
  })
  .strict();
export const TaskIconResolutionSchema = z
  .object({
    task_id: z.uuid(),
    assignment_id: z.uuid(),
    icon_id: TaskIconIdSchema,
    status: z.enum(["pending", "ready", "unavailable"]),
  })
  .strict();
export const TaskIconResolveResponseSchema = z
  .object({
    items: z.array(TaskIconResolutionSchema),
    request_id: z.string(),
  })
  .strict();
export const TaskIconJobSchema = z
  .object({
    type: z.literal("task.icon.select"),
    schema_version: z.literal(1),
    job_id: z.uuid(),
    workspace_id: z.uuid(),
    fingerprint: z.string().regex(/^[a-f0-9]{64}$/u),
    created_at: z.number().int().nonnegative(),
  })
  .strict();
export type TaskIconJob = z.infer<typeof TaskIconJobSchema>;
